<template>
  <div class="flex-container d-flex flex-column ai-center bg-gradual">
    <div class="bg-rest" />
    <div
      class="section-wrapper d-flex flex-column jc-start mg-50 ai-center relative"
    >
      <div class="roadmap-bubble bubble-start relative">
        <div class="roadmap-bubble-header">기업들이 겪는 비즈니스 장벽들</div>
        <div class="roadmap-bubble-content">
          <div class="block-item">
            <v-img
              :max-height="30"
              :min-height="30"
              :max-width="30"
              contain
              :src="understanding"
            >
            </v-img>
            <div class="bubble-content-text mt-5 text-center">
              비용 부담 및
              <br />
              투자 여력부족
            </div>
          </div>
          <div class="block-item">
            <v-img
              :max-height="30"
              :min-height="30"
              :max-width="30"
              contain
              :src="professional"
            >
            </v-img>
            <div class="bubble-content-text mt-5 text-center">전문성 부족</div>
          </div>

          <div class="block-item">
            <v-img
              :max-height="30"
              :min-height="30"
              :max-width="30"
              contain
              :src="trend"
            >
            </v-img>
            <div class="bubble-content-text mt-5 text-center">
              트렌트 분석 및
              <br />
              소비자 니즈
              <br />
              파악의 어려움
            </div>
          </div>
          <div class="block-item">
            <v-img
              :max-height="30"
              :min-height="30"
              :max-width="30"
              contain
              :src="time"
            >
            </v-img>
            <div class="bubble-content-text mt-5 text-center">
              낮은 업무
              <br />
              효율로 인한
              <br />
              시간낭비
            </div>
          </div>
          <div class="block-item">
            <v-img
              :max-height="30"
              :min-height="30"
              :max-width="30"
              contain
              :src="target"
            >
            </v-img>
            <div class="bubble-content-text mt-5 text-center">
              타겟 선정 등의
              <br />
              예측 불가한
              <br />
              영역
            </div>
          </div>
          <div class="block-item">
            <v-img
              :max-height="30"
              :min-height="30"
              :max-width="30"
              contain
              :src="track"
            >
            </v-img>
            <div class="bubble-content-text mt-5 text-center">
              신제품/서비스
              <br />
              인지도등 중요 정보
              <br />
              트래킹 불가
            </div>
          </div>
        </div>
      </div>

      <div class="roadmap-bubble bubble-middle relative">
        <div class="roadmap-bubble-header">데이터바우처 지원사업</div>
        <div class="flex-container jc-center ai-center pl-3">
          <v-img contain :max-height="250" :max-width="250" :src="graph" />
        </div>
      </div>

      <div class="roadmap-bubble bubble-end relative">
        <div class="roadmap-bubble-header">사업역량 향상</div>
        <div class="flex-container flex-column ai-center">
          <div class="roadmap-bubble-content">
            <div class="block-item">
              <v-img
                :max-height="30"
                :min-height="30"
                :max-width="30"
                contain
                :src="develop"
              >
              </v-img>
              <div class="bubble-content-text mt-5 text-center">
                기존 서비스 및
                <br />
                제품 고도화
              </div>
            </div>
            <div class="block-item">
              <v-img
                :max-height="30"
                :min-height="30"
                :max-width="30"
                contain
                :src="solution"
              >
              </v-img>
              <div class="bubble-content-text mt-5 text-center">
                다양한 솔루션<br />
                전략 수립
              </div>
            </div>

            <div class="block-item">
              <v-img
                :max-height="30"
                :min-height="30"
                :max-width="30"
                contain
                :src="efficiency"
              >
              </v-img>
              <div class="bubble-content-text mt-5 text-center">
                업무 효율성 향상
              </div>
            </div>
            <div class="block-item">
              <v-img
                :max-height="30"
                :min-height="30"
                :max-width="30"
                contain
                :src="track"
              >
              </v-img>
              <div class="bubble-content-text mt-5 text-center">
                실시간 소비자
                <br />
                반응 트래킹
              </div>
            </div>
            <div class="block-item">
              <v-img
                :max-height="30"
                :min-height="30"
                :max-width="30"
                contain
                :src="insight"
              >
              </v-img>
              <div class="bubble-content-text mt-5 text-center">
                다양한 마케팅
                <br />
                인사이트 도출
              </div>
            </div>
            <div class="block-item">
              <v-img
                :max-height="30"
                :min-height="30"
                :max-width="30"
                contain
                :src="monitoring"
              >
              </v-img>
              <div class="bubble-content-text mt-5 text-center">
                생산 모니터링
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="mg-150"></div>
      <div class="mg-150"></div>
    </div>
  </div>
</template>

<script>
import quote from "@/assets/quote.svg";
import arrow from "@/assets/arrow.svg";
import government from "@/assets/government.svg";
import company from "@/assets/company.svg";
import target from "@/assets/target.svg";
import time from "@/assets/time.svg";
import trend from "@/assets/trend.svg";
import professional from "@/assets/professional.svg";
import understanding from "@/assets/understanding.svg";
import track from "@/assets/track.svg";
import develop from "@/assets/develop.svg";
import solution from "@/assets/solution.svg";
import efficiency from "@/assets/efficiency.svg";
import insight from "@/assets/insight.svg";
import monitoring from "@/assets/monitoring.svg";
import gradual from "@/assets/gradual.png";
import graph from "@/assets/graph.svg";

export default {
  data: () => ({
    quote: quote,
    arrow: arrow,
    graph: graph,
    government: government,
    company: company,
    target: target,
    time: time,
    trend: trend,
    professional: professional,
    understanding: understanding,
    track: track,
    develop: develop,
    solution: solution,
    efficiency: efficiency,
    insight: insight,
    monitoring: monitoring,
    gradual: gradual,
  }),
};
</script>

<style>
.bg-gradual {
  background-image: url("../assets/gradual.png");
  background-size: 1920px 920px;
  background-position: center bottom;
  min-height: 1260px;
  min-width: 1920px;
}

.bg-rest {
  background: #cde9ff;
  width: 100%;
  min-height: 340px;
}

.roadmap-bubble {
  width: 340px;
  height: 340px;
  padding: 10px;
  border-radius: 50%;
  background: white;
  border: 5px solid transparent;
  box-shadow: inset 0 0 0px 1px #554c4344;
  border-spacing: 10px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.roadmap-bubble-header {
  position: absolute;
  top: 10px;
  left: 80%;

  transform: translateX(-50%);
  white-space: nowrap;
  font-size: 12px;
  font-weight: bold;
  color: white;
  padding: 5px 10px;
  background: #e66444;
  border: 3px solid white;
  text-align: center;
}

.roadmap-bubble-content {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  gap: 8px;
  color: #554c43;
  font-weight: 500;
  margin-top: 10px;
}

.bubble-content-text {
  font-size: 11px;
}

.bubble-start {
  position: absolute;
  top: 0px;
  left: 0px;
}

.bubble-middle {
  position: absolute;
  top: -150px;
  left: 50%;
  transform: translateX(-50%);
}

.bubble-end {
  position: absolute;
  top: -300px;
  right: 0px;
}
</style>